module.exports = __webpack_public_path__ + "img/Up.5c1923f2.jpg";